"use client";
import { useRef } from "react";
import Image from "next/image";

import ScrambleLink from './ScrambleLink';

export default function FirstArea(
    {
        classWrap='',
        title='false',
        sub='',
        classSub='',
        isAbout=false,
    }:
    {
        classWrap?: string;
        title: string;
        sub?: string;
        classSub?: string;
        isAbout?: boolean;
    }
) {

    return (
        <div className={`${classWrap && classWrap} font-Time relative flex flex-col justify-between w-full h-[380px] m-0 pt-[20px] px-Space-10-20 lg:px-[20px] lg:h-[28vw]`}>
            <h1 className="inline-block text-[6rem] text-nowrap [writing-mode:vertical-lr] leading-[0.9] lg:leading-[1.1] lg:text-[5.6vw] lg:[writing-mode:unset]">
                <ScrambleLink
                    classLink='inline-block w-[54px] lg:w-auto'
                    title={title}
                    url='/'
                    sameTitle={false}
                    fixWidth={false}
                />
            </h1>
            {sub && (
                <div className={`${classSub && classSub} text-[1.8rem] self-end lg:self-start lg:text-f-vw-24`}>{sub}</div>
            )}

            {isAbout && (
                <div className={`w-[35.8vw] self-end lg:w-[220px] lg:self-start`}>
                    <Image
                        src='/images/svg/logo-sd.svg'
                        width={300}
                        height={41}
                        className="w-full h-auto"
                        alt='seitaro design'
                        priority
                    />
                </div>
            )}
        </div>
    );
}
